"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Icon_1 = __importDefault(require("../../../common/js/atoms/Icon"));
const UserButtonDropdownItem = ({ onClick, icon, title, href, target, }) => {
    return (react_1.default.createElement(react_1.default.Fragment, null, !!href ? (react_1.default.createElement("a", { href: href, target: target, className: "znd-user-button__dropdown-item", onClick: (event) => onClick(event) },
        react_1.default.createElement(Icon_1.default, { name: icon }),
        title)) : (react_1.default.createElement("div", { className: "znd-user-button__dropdown-item", onClick: (event) => onClick(event) },
        react_1.default.createElement(Icon_1.default, { name: icon }),
        title))));
};
exports.default = UserButtonDropdownItem;
